/**
 * Define variables that may differ between deployment environments.
 *
 * Update this file as needed before creating a production build.
 */

// This should match the URL used in the mastercms to redirect to
// this client app, so that the URL won't change.
const routerBase = '/app/';

let baseUrl = '';
if (process.env.CMS_BASE_URL) {
  baseUrl = process.env.CMS_BASE_URL;
}

const apiUrl = baseUrl + '/api/v1/';
let websocketUrl = baseUrl.replace('http', 'ws') + '/ws/';
if (window.location.origin === 'http://localhost:8080') {
  websocketUrl = 'ws://localhost:8000/ws/';
}
const passwordResetUrl = baseUrl + '/client/pwreset';

// These may stay as they are in both dev and prod.
const websiteUrl = 'https://www.myshopradio.de';
const dataPrivacyURL = websiteUrl + '/datenschutz';
const generalTermsAndConditionsUrl = websiteUrl + '/agb';
const imprintUrl = websiteUrl + '/impressum';

// const prodCMSUrl = 'http://localhost:8000';
const prodCMSUrl = 'https://cms.myshopradio.de';

const mediaUrl = prodCMSUrl + '/media/';
const troubleshootingUrl = prodCMSUrl + '/client/monitoring/troubleshooting';

export default {
  router: {
    base: routerBase,
  },
  urls: {
    api: apiUrl,
    dataprivacy: dataPrivacyURL,
    gtc: generalTermsAndConditionsUrl,
    imprint: imprintUrl,
    media: mediaUrl,
    passwordReset: passwordResetUrl,
    prod: prodCMSUrl,
    troubleshooting: troubleshootingUrl,
    website: websiteUrl,
    websocket: websocketUrl,
  },
  contentsCachingEnabled: true,
  name: process.env.NODE_ENV,
};



// WEBPACK FOOTER //
// ./src/environment.js